const states = new WeakMap()

export const lock = document => {
  states.set(document, true)
}

export const unlock = document => {
  states.set(document, false)
}

export const unlocked = document => {
  return states.get(document) ?? true
}
